import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HisBackendService } from 'hisng';

@Injectable()
export class GlobalIdentifierTypeService {

    constructor( private backendService: HisBackendService ) { }

    // Get global identifier from database
    getGlobalIdentifierValuesByEntity( entity: string ): Observable<any[]> {
        return this.backendService.getData( `api/v1/fs/res/${entity}/globalIdentifierType` );
    }
}
